module.exports = __webpack_public_path__ + "4b4c074dfc5027c4b494d9a2704f4df1.pdf";